<!--
/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */
-->

<header class="osk-header">
  <nav class="navbar">
    <a [routerLink]="['/']" class="logo-link" aria-label="OSKEY Home">
      <osk-logo [height]="24" color="primary" />
    </a>
    <div class="nav-actions">
      @if (currentUser().firebaseUser) {
        @if (currentUser().selectedAccount) {
          <a [routerLink]="['/admin']" class="nav-icon-btn" aria-label="Admin Portal">
            <osk-icon name="settings" [size]="18" />
          </a>
        }
        <div class="user-menu-wrapper">
          <button
            type="button"
            class="user-profile-btn"
            (click)="toggleMenu($event)"
            [attr.aria-expanded]="isMenuOpen()"
            aria-haspopup="menu"
            data-automation-id="user-profile-btn"
            aria-label="User menu"
          >
            <osk-avatar
              size="sm"
              color="primary"
              [initials]="userInitials"
              [src]="currentUser().firebaseUser?.photoURL || undefined"
            />
          </button>
          @if (isMenuOpen()) {
            <div class="osk-user-dropdown" role="menu">
              <div class="user-menu-summary">
                @if (
                  currentUser().oskUser?.publicProfile?.firstName ||
                  currentUser().oskUser?.publicProfile?.lastName
                ) {
                  <div class="user-menu-name">
                    {{ currentUser().oskUser?.publicProfile?.firstName }}
                    {{ currentUser().oskUser?.publicProfile?.lastName }}
                  </div>
                }
                <div class="user-menu-email">{{ currentUser().firebaseUser?.email }}</div>
              </div>
              <button
                type="button"
                role="menuitem"
                (click)="signOut()"
                data-automation-id="signout-btn"
                class="user-signout-item"
              >
                <osk-icon name="log-out" [size]="16" />
                <span>{{ 'header.signOut' | oskTranslate | async }}</span>
              </button>
            </div>
          }
        </div>
      } @else {
        <osk-button
          color="primary"
          appearance="solid"
          size="sm"
          data-automation-id="login-btn"
          [link]="'/auth'"
        >
          {{ 'auth.signIn.signIn' | oskTranslate | async }}
        </osk-button>
      }
    </div>
  </nav>
</header>
